import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Navbar as BsNavbar, Nav, Button, Container, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '@rd-web-markets/shared/dist/store/features/authSlice';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';
import { Persona } from '@rd-web-markets/shared/dist/util/Persona';
import logo from '@assets/images/logo.png';
import HelpModal from '@rd-web-markets/shared/dist/navbar/HelpModal';
import flag from './flag.png';
import localLanguagesService from '@services/local_languages.service';
import { LOCAL_LANGUAGES } from '../../constants';
import ToReleaseNotesButton from 'src/pages/shared/release_notes/ToReleaseNotesButton';
export default function Navbar(_ref) {
  let {
    basename,
    match,
    userRole
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);
  const onLogOut = e => {
    e.preventDefault();
    UserService.logout().then(() => {
      dispatch(logout());
      history.replace('/login');
    }).catch(err => dispatch(handleError(err.description)));
  };
  const onChange = async e => {
    try {
      await localLanguagesService.update(e.target.value);
      window.location.reload();
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HelpModal, {
    show: modalOpen,
    onHide: () => setModalOpen(false)
  }), /*#__PURE__*/React.createElement(BsNavbar, {
    sticky: "top",
    expand: "md"
  }, /*#__PURE__*/React.createElement(Container, {
    className: "navbar-container"
  }, /*#__PURE__*/React.createElement(BsNavbar.Brand, {
    href: `${userRole}`
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: "Ayming Logo",
    height: "42"
  })), /*#__PURE__*/React.createElement(BsNavbar.Toggle, {
    "aria-controls": "basic-navbar-nav"
  }), /*#__PURE__*/React.createElement(BsNavbar.Collapse, {
    id: "basic-navbar-nav"
  }, /*#__PURE__*/React.createElement(Nav, {
    className: "me-auto",
    id: "navbar-breadcrumbs"
  }), /*#__PURE__*/React.createElement(Nav, {
    className: "navbar-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "me-4"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "locale",
    onChange: onChange,
    size: "md",
    type: "text",
    value: user.local_language
  }, LOCAL_LANGUAGES.map(language => /*#__PURE__*/React.createElement("option", {
    key: language,
    value: language
  }, language)))), /*#__PURE__*/React.createElement(Persona, {
    user: user
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: onLogOut
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "logout")), /*#__PURE__*/React.createElement(ToReleaseNotesButton, null), /*#__PURE__*/React.createElement(Button, {
    className: "ms-3",
    variant: "text",
    onClick: () => setModalOpen(true)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 blue"
  }, "question_mark")), /*#__PURE__*/React.createElement("div", {
    className: "ps-3 mt-1"
  }, /*#__PURE__*/React.createElement("img", {
    src: flag,
    alt: "Ayming Flag",
    height: "30"
  })))))));
}